import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import { NavLink } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './ModelEvaluation.css';

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

const ModelEvaluation = () => {
  const [showModal, setShowModal] = useState(true);
    const [hasPaidTrue, setHasPaidTrue] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
  
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;
  
    const handleContactClick = () => {
      setShowModal(false);
      setShowContactModal(true);
    };

  return (
    <div className='evalBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='maincontent'>
        <div className='evaluation-container'>
          <div className='Eval-card-accent'/>
          <br/>
          <img src="ModelEval.png" alt="Logo" className='eval-image' />
          <div className='textContent'>
            <h2 className='headingcenter'>Deploy Responsible AI - On Your Terms</h2>
            <p className='textCenter'>End-to-End Tools for Responsible AI Success</p>
            <div className='EvalContainer'>
              <div className='Eval2'>
                <div className='evalcolumns'>
                  <h2>What is Responsible AI?</h2>
                  <p>Responsible AI is an approach to assessing, developing, and deploying AI systems in a safe, trustworthy and ethical manner.
                  The Responsible AI toolbox is a collection of integrated tools and functionalities to help operationalise Responsible AI in practice. With the capabilities of this toolbox, you can assess your models and make user-facing decisions, faster and easier.</p>
                  <p><b>Core Principles of Responsible AI:</b></p>
                  <ul>
                    <li><b>Fairness & Bias Mitigation:</b> Ensure AI systems treat all user groups equitably and avoid discriminatory outcomes through rigorous testing and bias detection.</li>
                    <li><b>Transparency & Explainability:</b> Provide clear insights into how AI models make decisions, enabling trust and accountability for users and stakeholders.</li>
                    <li><b>Reliability & Safety:</b> Maintain consistent, predictable performance with fail-safes to prevent harmful consequences in real-world deployment.</li>
                  </ul>
                </div>
                <div className='evalcolumns'>
                  <h2>Introducing the Responsible AI Dashboard</h2>
                  <p>Responsible AI dashboard is a single pane of glass, enabling you to easily flow through different stages of model debugging (identification, diagnosis, and mitigation) and decision-making. This customisable experience can be taken in a multitude of directions, from analysing the model or data holistically, to conducting a deep dive or comparison on cohorts of interest, to explaining and perturbing model predictions for individual instances, and to informing users on business decisions and actions.</p>
                  <p><b>The dashboard can help you:</b></p>
                  <ul>
                    <li>Design workflows that interactively connect insights from a variety of model debugging and decision-making tools to create a holistic responsible assessment.</li>
                    <li>Customise the dashboard based on your unique tooling needs and preferences.</li>
                  </ul>
                </div>
              </div>
              <br/>
              <h2 className='headingcenter'>Operationalise Responsible AI, your way.</h2>
              <p className='textCenter'>A suite of tools for a customised, end-to-end responsible AI experience</p>
              {/*<p className='textCenterBold'>Download the notebooks for the different dashboard's and capabilities that the Ai Toolbox can offer.</p>*/}
              {/* {hasPaidTrue && (
                <div className='button-group'>
                  <a href="https://github.com/idattani/ResponsibleAI" target="_blank">
                      <button className="download-button" disabled={isDisabled}>Get Started</button>
                  </a>
                </div>
              )} */}
              <div className='button-group'>
                <NavLink 
                  to="/ContactUs" 
                >
                  <button className='download-button' >Contact Us</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelEvaluation;
